import { createApi } from '@reduxjs/toolkit/query/react';
import { waServicesQuery } from './baseQueries';
import { RecordResponse } from '../models/ServiceTypes';

export interface InvestorModel {
  InvestorId: number;
  InvestorName: string;
  EstateId?: number | null;
  UserId?: number | null;
  InvestorHHId?: number | null;
}

export type InvestorsResponse = RecordResponse<InvestorModel>;

// TODO: change to simple Investors api so advisors can use it too

export const adminInvestorsApi = createApi({
  reducerPath: 'adminInvestorsApi',
  baseQuery: waServicesQuery,
  endpoints: (builder) => ({
    getInvestors: builder.query<
      RecordResponse<InvestorModel>,
      {
        searchTerm?: string;
        sort?: { Property: string; Direction: string }[];
        limit?: number;
      }
    >({
      query: ({
        searchTerm = '',
        sort = [{ Property: 'InvestorName', Direction: 'asc' }],
        limit = 100,
      }) => ({
        url: `/api/Administrator/Investors/`,
        method: 'GET',
        params: {
          SearchTerm: searchTerm,
          sort: sort,
          limit: limit,
        },
      }),
    }),
  }),
});

export const { useGetInvestorsQuery } = adminInvestorsApi;
